import { ChevronDown } from "lucide-react";
import React, { useState } from "react";

export default function QuestionsAccordion({ obj }) {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggle = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="w-full">
      {obj.map((item, index) => (
        <div
          key={index}
          className="bg-gray-100 rounded-lg mb-3 overflow-hidden hover:shadow-md transition-all duration-100"
        >
          <button
            className="flex justify-between items-center w-full p-2 sm:p-5 text-left transition-colors duration-200 hover:bg-gray-200"
            onClick={() => toggle(index)}
            aria-expanded={activeIndex === index}
          >
            <span className="text-base text-sm text-gray-900 pr-4">
              {item.question}
            </span>
            <ChevronDown 
              className={`w-5 h-5 text-gray-600 flex-shrink-0 transition-transform duration-200 ${
                activeIndex === index ? 'rotate-180' : ''
              }`}
            />
          </button>
          
          <div
            className={`transition-all duration-300 ease-in-out overflow-hidden ${
              activeIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
            }`}
          >
            <div className="px-4 sm:px-5 pb-4 sm:pb-5">
              <div className="text-gray-600 text-sm leading-relaxed whitespace-pre-line">
                {item.answer}
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
